export enum RiskTypesEnum {
  CONSERVATIVE = 'CONSERVATIVE',
  MODERATE_CONSERVATIVE = 'MODERATE_CONSERVATIVE',
  MODERATE = 'MODERATE',
  MODERATE_AGGRESSIVE = 'MODERATE_AGGRESSIVE',
  AGGRESSIVE = 'AGGRESSIVE',
  UNKNOWN = 'UNKNOWN',
}

export enum RiskDescriptionEnum {
  VERY_CONSERVATIVE = 'Very Conservative',
  CONSERVATIVE = 'Conservative',
  MODERATE = 'Moderate',
  AGGRESSIVE = 'Aggressive',
  VERY_AGGRESSIVE = 'Very Aggressive',
  UNKNOWN = 'Unknown',
}
